import React from "react";
import LandingLayout from "../landing/LandingLayout";
import { ContactPage } from "../landing/ContactPage";

export default function Contact() {
  return (
    <LandingLayout>
      <ContactPage />
    </LandingLayout>
  );
}
